import { HttpClient } from '../HttpClient';
/**
 * * Get Client's Country
 */
export const GetClientCountry = async () => {
  try {
    const { data } = await HttpClient.get('api/clients/country');
    return await Promise.resolve(data)
  } catch (err) {
    return Promise.reject(err)
  }
};
